import { authPost } from "@api";

import { TokenPostParams, TokenResponse } from "@pages/settings/types";

export const createToken = (
  deploymentId: string,
  setTemporary: boolean = false
): Promise<TokenResponse> => {
  const path = `/api/agent/deployments/${deploymentId}/tokens`;
  const body = { temporary: setTemporary };
  return authPost<TokenPostParams, TokenResponse>(path, body);
};
